var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-carousel-slide',{attrs:{"caption":_vm.caption,"text":_vm.text,"img-src":_vm.imgSrc}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }